import { render, staticRenderFns } from "./ProfileVideo.vue?vue&type=template&id=e43ecf02&scoped=true"
import script from "./ProfileVideo.vue?vue&type=script&lang=js"
export * from "./ProfileVideo.vue?vue&type=script&lang=js"
import style0 from "./ProfileVideo.vue?vue&type=style&index=0&id=e43ecf02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43ecf02",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Video: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Video.vue').default,VisualCard: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/VisualCard.vue').default,Section: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Section.vue').default})
